"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var angular_1 = __importDefault(require("angular"));
var edit_form_template_html_1 = __importDefault(require("./edit-form-template.html"));
var edit_form_template_controller_1 = __importDefault(require("./edit-form-template.controller"));
function getFormTemplate($stateParams, FormTemplateModel) {
    return FormTemplateModel.get($stateParams.template_id).then(function (response) {
        return response.form_template;
    });
}
getFormTemplate.$inject = ["$stateParams", "FormTemplateModel"];
function getQuestions($stateParams, FormTemplateModel) {
    return FormTemplateModel.getQuestions($stateParams.template_id, {
        per_page: 1,
        current_page: 0,
    }).then(function (response) {
        return response.questions;
    });
}
getQuestions.$inject = ["$stateParams", "FormTemplateModel"];
function config($stateProvider, $urlRouterProvider) {
    $stateProvider.state("drivecoach.admin.formtemplates.edit", {
        url: "/form-templates/{template_id}/edit",
        controller: "AdminEditFormTemplateController",
        controllerAs: "vm",
        template: edit_form_template_html_1.default,
        resolve: {
            formTemplate: getFormTemplate,
            questions: getQuestions,
        },
    });
}
config.$inject = ["$stateProvider", "$urlRouterProvider"];
exports.default = angular_1.default
    .module("drivecoach.admin.formtemplates.editformtemplate", [])
    .config(config)
    .controller("AdminEditFormTemplateController", edit_form_template_controller_1.default);
